// extracted by mini-css-extract-plugin
module.exports = {"loading":"my-courses_loading__0gAOI"};